import axios from "axios";

export function editTermsOfUse() {
  return axios.get("api/settings/terms-of-use/edit");
}

export function updateTermsOfUse(form) {
  return axios.post("api/settings/terms-of-use/update", form);
}
